import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { supabase } from '../lib/supabase';

export function OAuthCallback() {
  const navigate = useNavigate();

  useEffect(() => {
    const handleCallback = async () => {
      try {
        // Get code and state from URL
        const params = new URLSearchParams(window.location.search);
        const code = params.get('code');
        const state = params.get('state');
        
        if (!code) {
          console.error('No code parameter found');
          navigate('/auth');
          return;
        }

        // Get stored state
        const storedState = sessionStorage.getItem('oauth_state');
        if (!state || !storedState || state !== storedState) {
          console.error('Invalid state parameter');
          navigate('/auth');
          return;
        }

        // Exchange code for session
        const { error } = await supabase.auth.exchangeCodeForSession(code);
        if (error) throw error;

        // Get current session
        const { data: { session } } = await supabase.auth.getSession();
        if (!session) throw new Error('No session after code exchange');

        // Clear state
        sessionStorage.removeItem('oauth_state');

        // Parse state to get return path
        const { returnTo } = JSON.parse(atob(state));

        // Redirect to home or specified return path
        navigate(returnTo || '/');
      } catch (error) {
        console.error('OAuth callback error:', error);
        navigate('/auth');
      }
    };

    handleCallback();
  }, [navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#1A1B1E]">
      <div className="text-center">
        <div className="animate-spin rounded-full h-8 w-8 border-2 border-[var(--accent-color)] border-t-transparent mx-auto mb-4"></div>
        <p className="text-gray-400">Signing you in...</p>
      </div>
    </div>
  );
}